import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'MACD' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'MACD', label: 'MACD', pane: 'sub', params: [12, 26, 9], outputs: ['dif', 'dea', 'macd'], labels: ['Fast', 'Slow', 'Signal'], histogram: 'macd' })
